export const POINT_BAR_ANIMATION_DURATION = 2000;

export const BIRD_ANIMATION_DURATION = 4000;

export const TOWER_ANIMATION_DURATION = 2000;

export const BOLT_ANIMATION_DURATION = 2000;

export const POINT_TEXT_ANIMATION_DURATION = 2000;